import { BannerDTO } from '@/types/BannerDTO';
import { HttpMethod } from '@/types/HttpMethod';
import { apiSlice } from '@/services/api/apiSlice';

export const bannerApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBanners: build.query<BannerDTO[], void>({
      query: () => ({
        url: '/banner/active',
        method: HttpMethod.GET,
      }),
    }),
  }),
});

export const { useGetBannersQuery } = bannerApiSlice;
